import { getDNSHostingAccountsApiModule } from './dnsHostingAccounts';
import { getDNSHostingsApiModule } from './dnsHostings';
import { getDomainRegistrarAccountsApiModule } from './domainRegistrarAccounts';
import { getDomainRegistrarsApiModule } from './domainRegistrars';
import { getPlatformServersApiModule } from './platformServers';
import { getRotationGroupsApiModule } from './rotationGroups';
import { getServiceDomainsApiModule } from './serviceDomains';
import { getServiceOriginsApiModule } from './serviceOrigins';
import { getPlatformBettingDomainsApiModule } from './platformBettingDomains';

import type { AxiosInstance } from 'axios';

export function getDomainManagementApiModule(affiliatesApi: AxiosInstance) {
  return {
    ...getDNSHostingAccountsApiModule(affiliatesApi),
    ...getDNSHostingsApiModule(affiliatesApi),
    ...getDomainRegistrarAccountsApiModule(affiliatesApi),
    ...getDomainRegistrarsApiModule(affiliatesApi),
    ...getPlatformServersApiModule(affiliatesApi),
    ...getRotationGroupsApiModule(affiliatesApi),
    ...getServiceDomainsApiModule(affiliatesApi),
    ...getServiceOriginsApiModule(affiliatesApi),
    ...getPlatformBettingDomainsApiModule(affiliatesApi),
  }
}